import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import classnames from "classnames";
import styles from "@/styles/Steps.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconStepsActive = function IconStepsActive(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.109,19.341,0,20.571l1.233-6.107ZM2.446,13.251l4.875,4.876L20.572,4.876,15.7,0,2.446,13.251Z",
      transform: "translate(0.638 0.707)",
      fill: "none",
      stroke: "#e6e6e6",
      strokeWidth: "1"
    })
  }));
};
IconStepsActive.defaultProps = {
  viewBox: "0 0 21.918 21.917"
};
var IconStepsPrev = function IconStepsPrev(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M20,4.571,6.394,19,0,11.455l.634-.54,5.792,6.836L19.393,4Z",
      transform: "translate(0 -4)",
      fill: "#E6E6E6"
    })
  }));
};
IconStepsPrev.defaultProps = {
  width: "20",
  height: "15",
  viewBox: "0 0 20 15"
};
export default function Steps(_ref) {
  let {
    step,
    steps
  } = _ref;
  const lastStep = steps.length;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.steps, {
      [styles["steps--last"]]: step === lastStep
    }),
    children: steps.map((value, i) => /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.step, {
        [styles.prev]: step > i + 1,
        [styles.active]: step == i + 1,
        [styles.next]: step == i,
        [styles.first]: i == 0,
        [styles.between]: i > 0 && i + 1 < lastStep,
        [styles.last]: lastStep == i + 1
      }),
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.label,
        children: `STEP${i + 1}`
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.icon,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.activeIcon,
          children: /*#__PURE__*/_jsx(IconStepsActive, {})
        }), /*#__PURE__*/_jsx("span", {
          className: styles.prevIcon,
          children: /*#__PURE__*/_jsx(IconStepsPrev, {})
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.caption,
        children: value
      })]
    }, `step-${i}`))
  });
}